import * as React from 'react';
import { ReactNode, useContext } from 'react';
import { ProjectApi, SolrProjectReduced } from '../../../api/core';
import { SearchResult, SearchResultHeader } from './SearchResult';
import { BreakingList } from '../../detail/components/layout/BreakingList';
import { ExternalId } from '../../detail/components/ExternalId';
import { NavigateFunction, useNavigate } from 'react-router';
import { InternalLink } from '../../components/InternalLink';
import { AuthContext } from '../../../Auth/components/AuthProvider';
import { getAuthMiddleware } from '../../../Auth/utils/GetAuthMiddleware';
import { ToastContext, ToastContextType } from '../../../util/providers/ToastProvider';
import { IntlShape, useIntl } from 'react-intl';
import { deleteProject, requestDeleteProject } from '../../../util/actions/project-actions';
import { HierarchyBlock } from '../../components/HierarchyBlock';


export interface SearchResultProjectProps {
  key: number;
  position: number;
  result: SolrProjectReduced;
  redirectPath?: string;
}

export function SearchResultProject(props: SearchResultProjectProps): ReactNode {
  const {actions} = useContext(AuthContext);
  const projectApi: ProjectApi = new ProjectApi().withMiddleware(getAuthMiddleware(actions));
  const toast: ToastContextType = useContext(ToastContext);
  const intl: IntlShape = useIntl();
  const navigate: NavigateFunction = useNavigate();
  const {result} = props;

  const header: SearchResultHeader = {
    label: result.name.join(', '),
    url: `/project/${result.id}`,
  };

  const contents: ReactNode[] = [];
  if (result.gnd && result.gnd.length > 0) {
    contents.push(
      <BreakingList separator={'; '}>
        {result.gnd.map((externalId: string) => (
          <ExternalId id={{externalId, type: 'gnd'}} entity={'project'}/>
        ))}
      </BreakingList>,
    );
  }
  if (result.hierarchy && result.hierarchy.length > 1) {
    result.hierarchy.reverse();
    result.hierarchy.pop();
    contents.push(<HierarchyBlock initial={true} breakpoint={'xl'}>{
      result.hierarchy.map((element: string, idx: number): ReactNode => {
          const splitted: string[] = element.split('#', 2);
          return <InternalLink key={idx} to={`/project/${splitted[0]}`}>{splitted[1]}</InternalLink>;
        },
      )
    }</HierarchyBlock>);
  }

  return <SearchResult
    position={props.position}
    header={header}
    contents={contents}
    result={result}
    requestDelete={(): void => requestDeleteProject(projectApi, toast, intl, navigate, +result.id, result.name[0], props.redirectPath)}
    delete={(): void => deleteProject(projectApi, toast, intl, navigate, +result.id, result.name[0], props.redirectPath)}
    editUrl={`/project/${result.id}/edit`}
  />;
}
